import videojs from 'video.js';
const VideoJsMenuItemClass = videojs.getComponent('MenuItem');
export default class ConcreteMenuItem extends VideoJsMenuItemClass {
    item;
    qualityButton;
    plugin;
    constructor(player, item, qualityButton, plugin) {
        super(player, {
            label: item.label,
            selectable: true,
            selected: item.selected || false
        });
        this.item = item;
        this.qualityButton = qualityButton;
        this.plugin = plugin;
    }
    handleClick() {
        for (let i = 0; i < this.qualityButton.items.length; ++i) {
            this.qualityButton.items[i].selected(false);
        }
        this.plugin.setQuality(this.item.value);
        this.selected(true);
    }
}
